/* eslint-disable @typescript-eslint/no-explicit-any */
import { Module, Commit } from "vuex";

// Define the interface for the permission object
interface Permission {
  id: number;
}

// Define the type for the state
type PermissionsState = Permission[];

const initialState: PermissionsState = [];

export const permissions: Module<PermissionsState, any> = {
  state: initialState,
  mutations: {
    storePermissions(state: PermissionsState, permissions: Permission[]) {
      state.splice(0, state.length, ...permissions);
    },
  },
  actions: {
    fetchPermissions({ commit }: { commit: Commit }, items: Permission[]) {
      commit("storePermissions", items);
    },
  },
  getters: {
    getPermissionById:
      (state: PermissionsState) =>
      (id: number): Permission | undefined => {
        return state.find((permission) => permission.id === id);
      },
  },
};
